export interface ICountryState {
  name: string;
  key: string;
}

export const usStates: ICountryState[] = [
  { name: 'Alabama', key: 'AL' },
  { name: 'Alaska', key: 'AK' },
  { name: 'Arizona', key: 'AZ' },
  { name: 'Arkansas', key: 'AR' },
  { name: 'Armed Forces America', key: 'AA' },
  { name: 'Armed Forces Pacific', key: 'AP' },
  { name: 'Armed Forces', key: 'AE' },
  { name: 'California', key: 'CA' },
  { name: 'Colorado', key: 'CO' },
  { name: 'Connecticut', key: 'CT' },
  { name: 'Delaware', key: 'DE' },
  { name: 'Florida', key: 'FL' },
  { name: 'Georgia', key: 'GA' },
  { name: 'Guam', key: 'GU' },
  { name: 'Hawaii', key: 'HI' },
  { name: 'Idaho', key: 'ID' },
  { name: 'Illinois', key: 'IL' },
  { name: 'Indiana', key: 'IN' },
  { name: 'Iowa', key: 'IA' },
  { name: 'Kansas', key: 'KS' },
  { name: 'Kentucky', key: 'KY' },
  { name: 'Louisiana', key: 'LA' },
  { name: 'Maine', key: 'ME' },
  { name: 'Maryland', key: 'MD' },
  { name: 'Massachusetts', key: 'MA' },
  { name: 'Michigan', key: 'MI' },
  { name: 'Minnesota', key: 'MN' },
  { name: 'Mississippi', key: 'MS' },
  { name: 'Missouri', key: 'MO' },
  { name: 'Montana', key: 'MT' },
  { name: 'Nebraska', key: 'NE' },
  { name: 'Nevada', key: 'NV' },
  { name: 'New Hampshire', key: 'NH' },
  { name: 'New Jersey', key: 'NJ' },
  { name: 'New Mexico', key: 'NM' },
  { name: 'New York', key: 'NY' },
  { name: 'North Carolina', key: 'NC' },
  { name: 'North Dakota', key: 'ND' },
  { name: 'Ohio', key: 'OH' },
  { name: 'Oklahoma', key: 'OK' },
  { name: 'Oregon', key: 'OR' },
  { name: 'Pennsylvania', key: 'PA' },
  { name: 'Puerto Rico', key: 'PR' },
  { name: 'Rhode Island', key: 'RI' },
  { name: 'South Carolina', key: 'SC' },
  { name: 'South Dakota', key: 'SD' },
  { name: 'Tennessee', key: 'TN' },
  { name: 'Texas', key: 'TX' },
  { name: 'Utah', key: 'UT' },
  { name: 'Vermont', key: 'VT' },
  { name: 'Virgin Islands', key: 'VI' },
  { name: 'Virginia', key: 'VA' },
  { name: 'Washington DC', key: 'DC' },
  { name: 'Washington', key: 'WA' },
  { name: 'West Virginia', key: 'WV' },
  { name: 'Wisconsin', key: 'WI' },
  { name: 'Wyoming', key: 'WY' },
] as ICountryState[];

export const australiaStates: ICountryState[] = [
  { name: 'Australian Capital Territory', key: 'ACT' },
  { name: 'New South Wales', key: 'NSW' },
  { name: 'Northern Territory', key: 'NT' },
  { name: 'Queensland', key: 'QLD' },
  { name: 'South Australia', key: 'SA' },
  { name: 'Tasmania', key: 'TAS' },
  { name: 'Victoria', key: 'VIC' },
  { name: 'Western Australia', key: 'WA' },
];

export const thailandStates: ICountryState[] = [
  { name: 'Amnat Charoen', key: 'ACR' },
  { name: 'Ang Thong', key: 'ATG' },
  { name: 'Bueng Kan', key: 'BKN' },
  { name: 'Buriram', key: 'BRM' },
  { name: 'Chachoengsao', key: 'CCO' },
  { name: 'Chai Nat', key: 'CNT' },
  { name: 'Chaiyaphum', key: 'CPM' },
  { name: 'Chanthaburi', key: 'CTI' },
  { name: 'Chiang Mai', key: 'CMI' },
  { name: 'Chiang Rai', key: 'CRI' },
  { name: 'Chonburi', key: 'CBI' },
  { name: 'Chumphon', key: 'CPN' },
  { name: 'Kalasin', key: 'KSN' },
  { name: 'Kamphaeng Phet', key: 'KPT' },
  { name: 'Kanchanaburi', key: 'KRI' },
  { name: 'Khon Kaen', key: 'KKN' },
  { name: 'Krabi', key: 'KBI' },
  { name: 'Lampang', key: 'LPG' },
  { name: 'Lamphun', key: 'LPN' },
  { name: 'Loei', key: 'LEI' },
  { name: 'Lopburi', key: 'LRI' },
  { name: 'Mae Hong Son', key: 'MSN' },
  { name: 'Maha Sarakham', key: 'MKM' },
  { name: 'Mukdahan', key: 'MDH' },
  { name: 'Nakhon Nayok', key: 'NYK' },
  { name: 'Nakhon Pathom', key: 'NPT' },
  { name: 'Nakhon Phanom', key: 'NPM' },
  { name: 'Nakhon Ratchasima', key: 'NMA' },
  { name: 'Nakhon Sawan', key: 'NSN' },
  { name: 'Nakhon Si Thammarat', key: 'NRT' },
  { name: 'Nan', key: 'NAN' },
  { name: 'Nong Bua Lam Phu', key: 'NBP' },
  { name: 'Nong Khai', key: 'NKI' },
  { name: 'Nonthaburi', key: 'NBI' },
  { name: 'Pathum Thani', key: 'PTE' },
  { name: 'Phang Nga', key: 'PNA' },
  { name: 'Phatthalung', key: 'PLG' },
  { name: 'Phayao', key: 'PYO' },
  { name: 'Phetchabun', key: 'PNB' },
  { name: 'Phetchaburi', key: 'PBI' },
  { name: 'Phichit', key: 'PCT' },
  { name: 'Phitsanulok', key: 'PLK' },
  { name: 'Phra Nakhon Si Ayutthaya', key: 'AYA' },
  { name: 'Phrae', key: 'PRE' },
  { name: 'huket', key: 'PKT' },
  { name: 'Prachinburi', key: 'PRI' },
  { name: 'Prachuap Khiri Khan', key: 'PKN' },
  { name: 'Ranong', key: 'RNG' },
  { name: 'Ratchaburi', key: 'RBR' },
  { name: 'Rayong', key: 'RYG' },
  { name: 'Roi Et', key: 'RET' },
  { name: 'Sa Kaeo', key: 'SKW' },
  { name: 'Sakon Nakhon', key: 'SNK' },
  { name: 'Samut Prakan', key: 'SPK' },
  { name: 'Samut Sakhon', key: 'SKN' },
  { name: 'Samut Songkhram', key: 'SKM' },
  { name: 'Saraburi', key: 'SRI' },
  { name: 'Sing Buri', key: 'SBR' },
  { name: 'isaket', key: 'SSK' },
  { name: 'Sukhothai', key: 'STI' },
  { name: 'Suphan Buri', key: 'SPB' },
  { name: 'Surat Thani', key: 'SNI' },
  { name: 'Surin', key: 'SRN' },
  { name: 'Tak', key: 'TAK' },
  { name: 'Trang', key: 'TRG' },
  { name: 'Trat', key: 'TRT' },
  { name: 'Ubon Ratchathani', key: 'UBN' },
  { name: 'Udon Thani', key: 'UDN' },
  { name: 'Uthai Thani', key: 'UTI' },
  { name: 'Uttaradit', key: 'UTD' },
  { name: 'Yasothon', key: 'YST' },
];

export const indiaStates: ICountryState[] = [
  { name: 'Andhra Pradesh', key: 'AP' },
  { name: 'Arunachal Pradesh', key: 'AR' },
  { name: 'Assam', key: 'AS' },
  { name: 'Bihar', key: 'BR' },
  { name: 'Chhattisgarh', key: 'CG' },
  { name: 'Goa', key: 'GA' },
  { name: 'Gujarat', key: 'GJ' },
  { name: 'Haryana', key: 'HR' },
  { name: 'Himachal Pradesh', key: 'HP' },
  { name: 'Jammu and Kashmir', key: 'JK' },
  { name: 'Jharkhand', key: 'JH' },
  { name: 'Karnataka', key: 'KA' },
  { name: 'Kerala', key: 'KL' },
  { name: 'Madhya Pradesh', key: 'MP' },
  { name: 'Maharashtra', key: 'MH' },
  { name: 'Manipur', key: 'MN' },
  { name: 'Meghalaya', key: 'ML' },
  { name: 'Mizoram', key: 'MZ' },
  { name: 'Nagaland', key: 'NL' },
  { name: 'Odisha', key: 'OR' },
  { name: 'Punjab', key: 'PB' },
  { name: 'Rajasthan', key: 'RJ' },
  { name: 'Sikkim', key: 'SK' },
  { name: 'Tamil Nadu', key: 'TN' },
  { name: 'Telangana', key: 'TG' },
  { name: 'Tripura', key: 'TR' },
  { name: 'Uttar Pradesh', key: 'UP' },
  { name: 'Uttarakhand', key: 'UT' },
  { name: 'West Bengal', key: 'WB' },
];

export const franceStates: ICountryState[] = [
  { name: 'Alsace', key: 'ALS' },
  { name: 'Aquitaine', key: 'AQT' },
  { name: 'Auvergne', key: 'AUG' },
  { name: 'Brittany', key: 'BRI' },
  { name: 'Burgundy', key: 'BUR' },
  { name: 'Centre-Val de Loire', key: 'CEN' },
  { name: 'Champagne-Ardenne', key: 'CHA' },
  { name: 'Corsica', key: 'COR' },
  { name: 'Franche-Comte', key: 'FRC' },
  { name: 'Île-de-France', key: 'IDF' },
  { name: 'Ile-de-France', key: 'IDF' },
  { name: 'Languedoc-Roussillon', key: 'LAR' },
  { name: 'Limousin', key: 'LIM' },
  { name: 'Lorraine', key: 'LOR' },
  { name: 'Lower Normandy', key: 'LOW' },
  { name: 'Midi-Pyrenees', key: 'MID' },
  { name: 'Nord-Pas-de-Calais', key: 'NPD' },
  { name: 'Pays de la Loire', key: 'PLO' },
  { name: 'Picardie', key: 'PIC' },
  { name: 'Poitou-Charentes', key: 'POI' },
  { name: "Provence-Alpes-Côte d'Azur", key: 'PAC' },
  { name: "Provence-Alpes-Cote d'Azur", key: 'PAC' },
  { name: 'Rhone-Alpes', key: 'RHA' },
  { name: 'Upper Normandy', key: 'UPP' },
];

export const germanyStates: ICountryState[] = [
  { name: 'Baden-Württemberg', key: 'BW' },
  { name: 'Baden-Wurttemberg', key: 'BW' },
  { name: 'Bayern', key: 'BY' },
  { name: 'Berlin', key: 'BE' },
  { name: 'Brandenburg', key: 'BB' },
  { name: 'Bremen', key: 'HB' },
  { name: 'Hamburg', key: 'HH' },
  { name: 'Hessen', key: 'HE' },
  { name: 'Mecklenburg-Vorpommern', key: 'MV' },
  { name: 'Niedersachsen', key: 'NI' },
  { name: 'Nordrhein-Westfalen', key: 'NW' },
  { name: 'Saarland', key: 'SL' },
  { name: 'Sachsen', key: 'SN' },
  { name: 'Sachsen-Anhalt', key: 'ST' },
  { name: 'Schleswig-Holstein', key: 'SH' },
  { name: 'Thüringen', key: 'TH' },
  { name: 'Thuringen', key: 'TH' },
];

export const netherlandsStates: ICountryState[] = [
  { name: 'Drenthe', key: 'DR' },
  { name: 'Flevoland', key: 'FL' },
  { name: 'Friesland', key: 'FR' },
  { name: 'Gelderland', key: 'GE' },
  { name: 'Groningen', key: 'GR' },
  { name: 'Limburg', key: 'LI' },
  { name: 'North Brabant', key: 'NB' },
  { name: 'North Holland', key: 'NH' },
  { name: 'Overijssel', key: 'OV' },
  { name: 'South Holland', key: 'ZH' },
  { name: 'Utrecht', key: 'UT' },
  { name: 'Zeeland', key: 'ZE' },
];

export const ukStates: ICountryState[] = [
  { name: 'England', key: 'ENG' },
  { name: 'Scotland', key: 'SCO' },
  { name: 'Wales', key: 'WAL' },
  { name: 'Northern Ireland', key: 'NIR' },
];

export const spainStates: ICountryState[] = [
  { name: 'La Coruña', key: 'CL' },
  { name: 'La Coruna', key: 'CL' },
  { name: 'Álava', key: 'AV' },
  { name: 'Alava', key: 'AV' },
  { name: 'Albacete', key: 'AB' },
  { name: 'Alicante', key: 'AC' },
  { name: 'Almería', key: 'AL' },
  { name: 'Almeria', key: 'AL' },
  { name: 'Asturias', key: 'AS' },
  { name: 'Ávila', key: 'VC' },
  { name: 'Avila', key: 'VC' },
  { name: 'Badajoz', key: 'BA' },
  { name: 'Barcelona', key: 'B' },
  { name: 'Burgos', key: 'BU' },
  { name: 'Cáceres', key: 'CC' },
  { name: 'Caceres', key: 'CC' },
  { name: 'Cádiz', key: 'CA' },
  { name: 'Cadiz', key: 'CA' },
  { name: 'Cantabria', key: 'S' },
  { name: 'Castellón', key: 'CS' },
  { name: 'Castellon', key: 'CS' },
  { name: 'Ciudad Real', key: 'CR' },
  { name: 'Córdoba', key: 'CO' },
  { name: 'Cordoba', key: 'CO' },
  { name: 'Cuenca', key: 'CU' },
  { name: 'Girona', key: 'GI' },
  { name: 'Granada', key: 'GR' },
  { name: 'Guadalajara', key: 'GU' },
  { name: 'Huelva', key: 'HU' },
  { name: 'Huesca', key: 'H' },
  { name: 'Jaén', key: 'J' },
  { name: 'Jaen', key: 'J' },
  { name: 'La Rioja', key: 'LO' },
  { name: 'Las Palmas', key: 'GC' },
  { name: 'León', key: 'LE' },
  { name: 'Leon', key: 'LE' },
  { name: 'Lleida', key: 'L' },
  { name: 'Lugo', key: 'LU' },
  { name: 'Madrid', key: 'M' },
  { name: 'Málaga', key: 'MA' },
  { name: 'Malaga', key: 'MA' },
  { name: 'Murcia', key: 'MU' },
  { name: 'Navarra', key: 'NA' },
  { name: 'Ourense', key: 'OR' },
  { name: 'Palencia', key: 'P' },
  { name: 'Pontevedra', key: 'PO' },
  { name: 'Salamanca', key: 'SA' },
  { name: 'Santa Cruz de Tenerife', key: 'TF' },
  { name: 'Segovia', key: 'SG' },
  { name: 'Sevilla', key: 'SE' },
  { name: 'Soria', key: 'SO' },
  { name: 'Tarragona', key: 'T' },
  { name: 'Teruel', key: 'TE' },
  { name: 'Toledo', key: 'TO' },
  { name: 'Valencia', key: 'V' },
  { name: 'Valladolid', key: 'VA' },
  { name: 'Zamora', key: 'ZA' },
  { name: 'Zaragoza', key: 'Z' },
];

export const mexicoStates: ICountryState[] = [
  { name: 'Aguascalientes', key: 'AG' },
  { name: 'Baja California', key: 'BC' },
  { name: 'Baja California Sur', key: 'BS' },
  { name: 'Campeche', key: 'CM' },
  { name: 'Chiapas', key: 'CS' },
  { name: 'Chihuahua', key: 'CH' },
  { name: 'Coahuila', key: 'CO' },
  { name: 'Colima', key: 'CL' },
  { name: 'Distrito Federal', key: 'DF' },
  { name: 'Durango', key: 'DU' },
  { name: 'Guanajuato', key: 'GU' },
  { name: 'Guerrero', key: 'GR' },
  { name: 'Hidalgo', key: 'HI' },
  { name: 'Jalisco', key: 'JA' },
  { name: 'Mexico', key: 'ME' },
  { name: 'Michoacan', key: 'MI' },
  { name: 'Morelos', key: 'MO' },
  { name: 'Nayarit', key: 'NA' },
  { name: 'Nuevo Leon', key: 'NL' },
  { name: 'Oaxaca', key: 'OA' },
  { name: 'Puebla', key: 'PU' },
  { name: 'Queretaro', key: 'QE' },
  { name: 'Quintana Roo', key: 'QR' },
  { name: 'San Luis Potosi', key: 'SL' },
  { name: 'Sinaloa', key: 'SI' },
  { name: 'Sonora', key: 'SO' },
  { name: 'Tabasco', key: 'TB' },
  { name: 'Tamaulipas', key: 'TM' },
  { name: 'Tlaxcala', key: 'TL' },
  { name: 'Veracruz', key: 'VE' },
  { name: 'Yucatan', key: 'YU' },
  { name: 'Zacatecas', key: 'ZA' },
];

export const allSupportedStates = [
  ...australiaStates,
  ...franceStates,
  ...germanyStates,
  ...indiaStates,
  ...mexicoStates,
  ...netherlandsStates,
  ...usStates,
  ...thailandStates,
  ...ukStates,
  ...spainStates,
];

export function stateNamesToStateList(
  stateNames: string[],
  statesList: ICountryState[] = allSupportedStates,
): ICountryState[] {
  return statesList.filter((s: ICountryState) => stateNames.includes(s.name));
}

export function stateNameToStateKeyList(
  stateNames: string[],
  statesList: ICountryState[] = allSupportedStates,
): string[] {
  return statesList
    .filter((s: ICountryState) => stateNames.includes(s.name))
    .map((s: ICountryState) => s.key);
}
